"use client";!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();
import React from "react"
import { Typography } from "@mui/material"
import SectionContainer from "../shared/SectionContainer"
import styles from "./styles.module.scss"
import PrimaryAndSecondaryButtonsContainer from "../shared/PrimaryAndSecondaryButtonsContainer"
import YourGroupExampleScorecard from "./components/YourGroupExampleScorecard"
import useRedirectToLeaderOnboarding from "../../../../hooks/useRedirectToLeaderOnboarding"
import {
  PRIMARY_YELLOW_BUTTON_TYPE,
  SECONDARY_BUTTON_TYPE,
  ACCENT_COLOR,
} from "../shared/constants"

function NewsPaperHeader() {
  const [
    { isLoggedIn },
    { getRouteForLeaderOnboarding, getMonthlyListingsClickHandler },
  ] = useRedirectToLeaderOnboarding()
  const renderButtons = () => {
    return (
      <div className={styles["buttons-container"]}>
        <PrimaryAndSecondaryButtonsContainer
          button1={{
            type: PRIMARY_YELLOW_BUTTON_TYPE,

            text: "Post your group",
            href: getRouteForLeaderOnboarding(),
          }}
          button2={{
            type: SECONDARY_BUTTON_TYPE,
            text: "Get monthly listings",
            onClick: async () => {
              await getMonthlyListingsClickHandler()
            },
          }}
        />
      </div>
    )
  }
  const renderMobileHeader = () => {
    return (
      <div className={styles["mobile-header"]}>
        <Typography variant={"h1"}>
          <span style={{ color: ACCENT_COLOR }}>ZestLife helps</span> independent
          mental health professionals{" "}
          <span style={{ color: ACCENT_COLOR }}>
            find, fill, and facilitate groups.
          </span>
        </Typography>
      </div>
    )
  }
  const renderLeft = () => {
    return (
      <div className={styles["left-side"]}>
        <div className={styles["header"]}>
          <Typography variant={"h1"}>
            <span style={{ color: ACCENT_COLOR }}>ZestLife helps</span> independent
            mental health professionals{" "}
            <span style={{ color: ACCENT_COLOR }}>
              find, fill, and facilitate groups.
            </span>
          </Typography>
        </div>
        <div className={styles["body"]}>
          <Typography variant={"body1"}>
            A place to discover active mental wellness groups.
          </Typography>
        </div>
        {renderButtons()}
      </div>
    )
  }

  const renderRight = () => {
    return (
      <div className={styles["right-side"]}>
        <YourGroupExampleScorecard />
      </div>
    )
  }

  return (
    <SectionContainer color="faded-blue-news-paper-header">
      <div className={styles["container"]}>
        <div className={styles["left-right-container"]}>
          {renderLeft()}
          {renderRight()}
          {renderMobileHeader()}
        </div>
      </div>
    </SectionContainer>
  )
}
export default NewsPaperHeader
